import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";
import { Ou } from "@organizations/models";

@Injectable({ providedIn: "root" })
export class OuService {
  constructor(private http: HttpClient) {}

  getOu(organizationalUnitId: string): Observable<Ou> {
    return this.http.get<Ou>(`${environment.api.uri}/organizationalUnits/${organizationalUnitId}`);
  }

  updateOu(ou: Ou): Observable<Ou> {
    // Ignore the id and parentOrganizationId fields
    const body: Partial<Ou> = { ...ou };
    delete body.id;
    delete body.parentOrganizationId;
    return this.http.put<Ou>(`${environment.api.uri}/organizationalUnits/${ou.id}`, body);
  }

  createOu(ou: Ou): Observable<Ou> {
    // Ignore the id and parentOrganizationId fields
    const body: Partial<Ou> = { ...ou };
    delete body.id;
    delete body.parentOrganizationId;
    return this.http.post<Ou>(`${environment.api.uri}/organizationalUnits`, body);
  }

  deleteOu(ouId: string): Observable<null> {
    return this.http.delete<null>(`${environment.api.uri}/organizationalUnits/${ouId}`);
  }
}
